import React from 'react';
export default function TrendsTab() {
  return (
    <div className="alert alert-info mt-4">Trends and historical analysis coming soon.</div>
  );
}